import React, { useState, useEffect } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import TableHead from "@mui/material/TableHead";
import UserIcon from "../../images/user-octagon.svg";
import EditIcon from "../../images/editpencil.svg";
import "./PayrollAdminTable.scss";
import PayrollAdminModal from "../PayrollAdminModal/PayrollAdminModal";
import BaseCustomerTable from "../BaseCustomerTable/BaseCustomerTable";
import UserFace from "../../images/user.png";
import { getSystemStatus } from "../../util/API/admin";
import { Typography, Box, Button } from "@mui/material";
import { getUserDetails } from "../../util/API/customers";
import { RenderRoleBadges } from "../Navbar/UserProfile";
import Eye from "../../images/eye.svg";
import ViewOperators from "../../pages/Admin/ViewOperators";
import { getOperatorsList } from "../../store/redux/operator";
import { useDispatch } from "react-redux";
import PayrollAssociateCreation from "../PayrollAssociateCreation/PayrollAssociateCreation";
import ViewAssociates from "../../pages/PayrollAdmin/ViewAssociates";
import { decodeHtmlEntities } from "../../util/utilfunctions/utilFunctions";
export default function PayrollAdminTable({
  payrollFilterList,
  updateUser,
  setUpdateUser,
  payrollUsers,
  systemRoles,
  setIsViewOperators,
  isViewOperators,
  payRollAdminId,
  setIsViewAssociates,
  isViewAssociates,
  viewAssociatesAdmin, // ← add
  setViewAssociatesAdmin, // ← add
}) {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [open, setOpen] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [adminTable, setAdminTable] = useState(null);
  const [userStatus, setUserStatus] = useState([]);
  const [userRoles, setUserRoles] = useState([]);
  const [filteredUsers, setFilteredUsers] = useState([]);
  const [lastVisitedRow, setLastVisitedRow] = useState(null);
  const [openAssociate, setOpenAssociate] = useState(false);
  // const [isViewAssociates, setIsViewAssociates] = useState(false);
  // const [viewAssociatesAdmin, setViewAssociatesAdmin] = useState(null); // ← add
  const dispatch = useDispatch();

  const [sortConfig, setSortConfig] = useState({
    key: "role",
    direction: "ascending",
  });
  const cleanName = (name) =>
    decodeHtmlEntities(decodeHtmlEntities(name || ""))
      .replace(/[^a-zA-Z0-9\s'&.-]/g, "")
      .replace(/\s+/g, " ")
      .trim();
  useEffect(() => {
    setFilteredUsers(payrollFilterList);
  }, [payrollFilterList]);

  const handleClose = () => setOpen(false);

  const pageCount = Math.ceil(filteredUsers.length / rowsPerPage);
  const pageNumbers = Array.from({ length: pageCount }, (_, index) => index);
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const adminPortalStatus = async () => {
    const response = await getSystemStatus();
    setUserStatus(response.RunQuery4Class.data.body.payload);
  };

  const getUserRoles = async () => {
    setUserRoles(systemRoles);
  };

  const handleSelectedUser = async (id) => {
    const response = await getUserDetails(id);
    console.log(response);
    setSelectedUser(response);
    return response; // ← return it
  };
  // New dedicated handler for View Associates click
  const handleViewAssociates = async (id) => {
    const response = await getUserDetails(id);
    setSelectedUser(response);
    setViewAssociatesAdmin(response); // ← snapshot immediately from the resolved promise
    setIsViewAssociates(true);
  };
  async function getTable() {
    let response = await fetch(`/tables/adminTable.json`);
    const tableData = await response.json();
    setAdminTable(tableData);
    setRowsPerPage(parseInt(tableData.rowsPerPage));
  }

  useEffect(() => {
    getTable();
    adminPortalStatus();
    getUserRoles();
  }, []);

  const handleSort = (key) => {
    let direction = "ascending";
    if (sortConfig.key === key && sortConfig.direction === "ascending") {
      direction = "descending";
    }
    setSortConfig({ key, direction });
  };

  const sortData = (array, config) => {
    const sortedArray = [...array];

    if (config.key === "role") {
      sortedArray.sort((a, b) => {
        const roleA = a?.Securityuserrole?.roleid || "";
        const roleB = b?.Securityuserrole?.roleid || "";
        if (roleA < roleB) return config.direction === "ascending" ? -1 : 1;
        if (roleA > roleB) return config.direction === "ascending" ? 1 : -1;
        return 0;
      });
    }
    return sortedArray;
  };

  return (
    <>
      <PayrollAdminModal
        open={open}
        handleClose={handleClose}
        selectedUser={selectedUser}
        payrollFilterList={payrollFilterList}
        updateUser={updateUser}
        setUpdateUser={setUpdateUser}
        userStatus={userStatus}
        userRoles={userRoles}
        payrollUsers={payrollUsers}
        handleSelectedUser={handleSelectedUser}
      />

      <PayrollAssociateCreation
        open={openAssociate}
        handleClose={() => setOpenAssociate(false)}
        selectedUser={selectedUser}
        roles={systemRoles}
        updateUser={updateUser}
        setUpdateUser={setUpdateUser}
        payrollUsers={payrollUsers}
      />

      {isViewOperators && (
        <Box sx={{ display: "flex", justifyContent: "end" }}>
          <Button
            sx={{
              color: "#00365A",
              fontFamily: "Inter",
              fontSize: "14px",
              fontStyle: "normal",
              fontWeight: 500,
              lineHeight: "20px !important",
              borderRadius: "30px",
              border: "1px solid var(--grey-grey-30, #EAEEF4)",
              background: "var(--primary-white, #FFF)",
              padding: "5px 20px",
              display: "flex",
              gap: "13px",
              alignItems: "center",
            }}
            onClick={() => {
              setIsViewOperators(false);
              dispatch(getOperatorsList({ users: [] }));
            }}
          >
            <Box>Go Back</Box>
          </Button>
        </Box>
      )}

      {!isViewOperators && !isViewAssociates && (
        <TableContainer component={Paper} sx={{ boxShadow: "none" }}>
          <Table sx={{ minWidth: 500 }} aria-label="custom pagination table">
            <TableHead>
              <TableRow>
                <TableCell>
                  <img src={UserIcon} alt="User" />
                </TableCell>
                <TableCell align="left" className="customer-table-headers">
                  <Typography className="customer-table-headers">
                    Name
                  </Typography>
                </TableCell>
                {/* NEW COLUMN: Company Name */}
                <TableCell align="left" className="customer-table-headers">
                  <Typography className="customer-table-headers">
                    Company Name
                  </Typography>
                </TableCell>
                <TableCell align="left">
                  <Typography className="customer-table-headers">
                    Email
                  </Typography>
                </TableCell>
                <TableCell align="left" className="customer-table-headers">
                  <Typography className="customer-table-headers">
                    Account Status
                  </Typography>
                </TableCell>
                <TableCell
                  align="left"
                  className="customer-table-headers"
                  onClick={() => handleSort("role")}
                >
                  <Typography className="customer-table-headers">
                    User Roles{" "}
                    {sortConfig.key === "role" &&
                      (sortConfig.direction === "ascending" ? " 🔼" : " 🔽")}
                  </Typography>
                </TableCell>
                <TableCell align="left" className="customer-table-headers">
                  <Typography className="customer-table-headers">
                    Actions
                  </Typography>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {sortData(filteredUsers, sortConfig)
                // .filter((row) => {
                //   if (!row) return false;
                //   const roles = Array.isArray(row.Securityuserrole)
                //     ? row.Securityuserrole
                //     : [row.Securityuserrole];
                //   return !roles.some((role) => role?.roleid === "654");
                // })
                .filter((row) => {
                  if (!row) return false;
                  const roles = Array.isArray(row.Securityuserrole)
                    ? row.Securityuserrole
                    : row.Securityuserrole
                      ? [row.Securityuserrole]
                      : [];

                  // Must have payroll admin role AND must not have role 654
                  const hasPayrollRole = roles.some(
                    (role) => role?.roleid === payRollAdminId,
                  );
                  const hasExcludedRole = roles.some(
                    (role) => role?.roleid === "654",
                  );

                  return hasPayrollRole && !hasExcludedRole;
                })
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((row) => (
                  <TableRow
                    key={row?.Vuser?.id}
                    onClick={() => setLastVisitedRow(row?.Vuser?.id)}
                    sx={{
                      backgroundColor:
                        row?.Vuser?.id === lastVisitedRow
                          ? "#dbefff"
                          : "inherit",
                    }}
                  >
                    <TableCell component="th" scope="row" style={{ width: 50 }}>
                      <img
                        src={UserFace}
                        className="table-customer-photo"
                        alt="User"
                      />
                    </TableCell>
                    <TableCell style={{ width: 160 }} align="left">
                      <Typography className="email-admin-text">
                        {row?.Vuser?.firstName} {row?.Vuser?.lastName}
                      </Typography>
                    </TableCell>
                    {/* NEW CELL: Company Name */}
                    <TableCell style={{ width: 200 }} align="left">
                      <Typography
                        className="email-admin-text"
                        sx={{ fontWeight: 500 }}
                      >
                        {cleanName(row?.Vuser?.otherNames) || "-"}
                      </Typography>
                    </TableCell>
                    <TableCell style={{ width: 160 }} align="left">
                      <Typography className="email-admin-text">
                        {row?.Vuser?.emailAccount}
                      </Typography>
                    </TableCell>
                    <TableCell style={{ width: 160 }} align="left">
                      <Typography className="email-admin-text">
                        <span
                          className={
                            row?.Vuser?.status === "1"
                              ? "active-user"
                              : "disabled-user"
                          }
                        >
                          {userStatus
                            ? (
                                userStatus.find(
                                  (systemStatus) =>
                                    systemStatus?.userstatus?.statusID ===
                                    row?.Vuser?.status,
                                ) || {
                                  userstatus: { name: "Status not found" },
                                }
                              )?.userstatus?.name
                            : "Status not found"}
                        </span>
                      </Typography>
                    </TableCell>
                    <TableCell style={{ width: 160 }} align="left">
                      <Box className="button-container">
                        {row?.Securityuserrole ? (
                          <RenderRoleBadges
                            userRoles={row?.Securityuserrole}
                            systemRoles={systemRoles}
                          />
                        ) : (
                          "No roles assigned"
                        )}
                      </Box>
                    </TableCell>
                    <TableCell style={{ width: 200 }} align="left">
                      <Box className="admin-actions-container pointer">
                        <Box
                          className="modify-role-button"
                          onClick={() => {
                            handleSelectedUser(row?.Vuser?.id);
                            setOpen(true);
                          }}
                        >
                          <img src={EditIcon} alt="Edit" />
                          Modify Roles
                        </Box>
                        {(Array.isArray(row?.Securityuserrole)
                          ? row.Securityuserrole
                          : [row.Securityuserrole]
                        ).some((role) => role?.roleid === "653") && (
                          <Box
                            className="modify-role-button"
                            onClick={() => {
                              handleSelectedUser(row?.Vuser?.id);
                              setIsViewOperators(true);
                            }}
                          >
                            <img src={Eye} alt="View" loading="lazy" />
                            View Operators
                          </Box>
                        )}
                        <Box
                          className="modify-role-button"
                          onClick={() => {
                            handleSelectedUser(row?.Vuser?.id);
                            setOpenAssociate(true);
                          }}
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: "4px",
                            fontSize: "12.5px",
                            padding: "3px 8px",
                            cursor: "pointer",
                            color: "text.secondary",
                            "&:hover": { color: "primary.main" },
                          }}
                        >
                          <svg
                            width="14"
                            height="14"
                            viewBox="0 0 16 16"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <circle
                              cx="6"
                              cy="5"
                              r="3"
                              stroke="currentColor"
                              strokeWidth="1.4"
                            />
                            <path
                              d="M1 14c0-2.76 2.24-5 5-5s5 2.24 5 5"
                              stroke="currentColor"
                              strokeWidth="1.4"
                              strokeLinecap="round"
                            />
                            <line
                              x1="12"
                              y1="8"
                              x2="12"
                              y2="13"
                              stroke="currentColor"
                              strokeWidth="1.4"
                              strokeLinecap="round"
                            />
                            <line
                              x1="9.5"
                              y1="10.5"
                              x2="14.5"
                              y2="10.5"
                              stroke="currentColor"
                              strokeWidth="1.4"
                              strokeLinecap="round"
                            />
                          </svg>
                          Create Associate
                        </Box>
                        {(Array.isArray(row?.Securityuserrole)
                          ? row.Securityuserrole
                          : [row.Securityuserrole]
                        ).some((role) => role?.roleid !== "653") && (
                          <Box
                            className="modify-role-button"
                            onClick={() => {
                              handleViewAssociates(row?.Vuser?.id);
                            }}
                          >
                            <img
                              src={Eye}
                              alt="View Associates"
                              loading="lazy"
                            />
                            View Associates
                          </Box>
                        )}
                      </Box>
                    </TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
          <BaseCustomerTable
            page={page}
            onPageChange={handleChangePage}
            pageNumbers={pageNumbers}
          />
        </TableContainer>
      )}

      {isViewOperators && (
        <ViewOperators
          userid={selectedUser?.User?.id}
          selectedAgent={selectedUser}
          systemRoles={systemRoles}
          userStatus={userStatus}
        />
      )}
      {isViewAssociates && (
        <ViewAssociates
          parentAdmin={viewAssociatesAdmin}
          systemRoles={systemRoles}
          userStatus={userStatus}
          onGoBack={() => setIsViewAssociates(false)}
          updateUser={updateUser} // ← add
          setUpdateUser={setUpdateUser} // ← add
          payrollUsers={payrollUsers} // ← add
        />
      )}
    </>
  );
}
